import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('nordvik');

const NordvikPage = () => <CaseStudyPage project={project} />;

export default NordvikPage;
